module.exports = __webpack_public_path__ + "img/s-price.087b4718.svg";